/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PostPressKitBodyDocumentsInner } from './PostPressKitBodyDocumentsInner';
import {
    PostPressKitBodyDocumentsInnerFromJSON,
    PostPressKitBodyDocumentsInnerFromJSONTyped,
    PostPressKitBodyDocumentsInnerToJSON,
} from './PostPressKitBodyDocumentsInner';
import type { PostPressKitBodyGuidelineFilesInner } from './PostPressKitBodyGuidelineFilesInner';
import {
    PostPressKitBodyGuidelineFilesInnerFromJSON,
    PostPressKitBodyGuidelineFilesInnerFromJSONTyped,
    PostPressKitBodyGuidelineFilesInnerToJSON,
} from './PostPressKitBodyGuidelineFilesInner';
import type { PostPressKitBodyGuidelineText } from './PostPressKitBodyGuidelineText';
import {
    PostPressKitBodyGuidelineTextFromJSON,
    PostPressKitBodyGuidelineTextFromJSONTyped,
    PostPressKitBodyGuidelineTextToJSON,
} from './PostPressKitBodyGuidelineText';
import type { PostPressKitBodyImagesInner } from './PostPressKitBodyImagesInner';
import {
    PostPressKitBodyImagesInnerFromJSON,
    PostPressKitBodyImagesInnerFromJSONTyped,
    PostPressKitBodyImagesInnerToJSON,
} from './PostPressKitBodyImagesInner';
import type { PostPressKitBodyLogosInner } from './PostPressKitBodyLogosInner';
import {
    PostPressKitBodyLogosInnerFromJSON,
    PostPressKitBodyLogosInnerFromJSONTyped,
    PostPressKitBodyLogosInnerToJSON,
} from './PostPressKitBodyLogosInner';
import type { PostPressKitBodyProfilesInner } from './PostPressKitBodyProfilesInner';
import {
    PostPressKitBodyProfilesInnerFromJSON,
    PostPressKitBodyProfilesInnerFromJSONTyped,
    PostPressKitBodyProfilesInnerToJSON,
} from './PostPressKitBodyProfilesInner';
import type { PostPressKitBodyStatus } from './PostPressKitBodyStatus';
import {
    PostPressKitBodyStatusFromJSON,
    PostPressKitBodyStatusFromJSONTyped,
    PostPressKitBodyStatusToJSON,
} from './PostPressKitBodyStatus';
import type { PostPressKitBodyTagsInner } from './PostPressKitBodyTagsInner';
import {
    PostPressKitBodyTagsInnerFromJSON,
    PostPressKitBodyTagsInnerFromJSONTyped,
    PostPressKitBodyTagsInnerToJSON,
} from './PostPressKitBodyTagsInner';

/**
 * POST /press_kit
 * @export
 * @interface PostPressKitBody
 */
export interface PostPressKitBody {
    /**
     * 
     * @type {PostPressKitBodyStatus}
     * @memberof PostPressKitBody
     */
    status: PostPressKitBodyStatus;
    /**
     * 
     * @type {Array<PostPressKitBodyLogosInner>}
     * @memberof PostPressKitBody
     */
    logos: Array<PostPressKitBodyLogosInner>;
    /**
     * 
     * @type {Array<PostPressKitBodyImagesInner>}
     * @memberof PostPressKitBody
     */
    images: Array<PostPressKitBodyImagesInner>;
    /**
     * 
     * @type {PostPressKitBodyGuidelineText}
     * @memberof PostPressKitBody
     */
    guidelineText: PostPressKitBodyGuidelineText;
    /**
     * 
     * @type {Array<PostPressKitBodyGuidelineFilesInner>}
     * @memberof PostPressKitBody
     */
    guidelineFiles: Array<PostPressKitBodyGuidelineFilesInner>;
    /**
     * 
     * @type {Array<PostPressKitBodyDocumentsInner>}
     * @memberof PostPressKitBody
     */
    documents: Array<PostPressKitBodyDocumentsInner>;
    /**
     * 
     * @type {Array<PostPressKitBodyProfilesInner>}
     * @memberof PostPressKitBody
     */
    profiles: Array<PostPressKitBodyProfilesInner>;
    /**
     * 設定されているタグ一覧
     * @type {Array<PostPressKitBodyTagsInner>}
     * @memberof PostPressKitBody
     */
    tags: Array<PostPressKitBodyTagsInner>;
}

/**
 * Check if a given object implements the PostPressKitBody interface.
 */
export function instanceOfPostPressKitBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "logos" in value;
    isInstance = isInstance && "images" in value;
    isInstance = isInstance && "guidelineText" in value;
    isInstance = isInstance && "guidelineFiles" in value;
    isInstance = isInstance && "documents" in value;
    isInstance = isInstance && "profiles" in value;
    isInstance = isInstance && "tags" in value;

    return isInstance;
}

export function PostPressKitBodyFromJSON(json: any): PostPressKitBody {
    return PostPressKitBodyFromJSONTyped(json, false);
}

export function PostPressKitBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressKitBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': PostPressKitBodyStatusFromJSON(json['status']),
        'logos': ((json['logos'] as Array<any>).map(PostPressKitBodyLogosInnerFromJSON)),
        'images': ((json['images'] as Array<any>).map(PostPressKitBodyImagesInnerFromJSON)),
        'guidelineText': PostPressKitBodyGuidelineTextFromJSON(json['guideline_text']),
        'guidelineFiles': ((json['guideline_files'] as Array<any>).map(PostPressKitBodyGuidelineFilesInnerFromJSON)),
        'documents': ((json['documents'] as Array<any>).map(PostPressKitBodyDocumentsInnerFromJSON)),
        'profiles': ((json['profiles'] as Array<any>).map(PostPressKitBodyProfilesInnerFromJSON)),
        'tags': ((json['tags'] as Array<any>).map(PostPressKitBodyTagsInnerFromJSON)),
    };
}

export function PostPressKitBodyToJSON(value?: PostPressKitBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': PostPressKitBodyStatusToJSON(value.status),
        'logos': ((value.logos as Array<any>).map(PostPressKitBodyLogosInnerToJSON)),
        'images': ((value.images as Array<any>).map(PostPressKitBodyImagesInnerToJSON)),
        'guideline_text': PostPressKitBodyGuidelineTextToJSON(value.guidelineText),
        'guideline_files': ((value.guidelineFiles as Array<any>).map(PostPressKitBodyGuidelineFilesInnerToJSON)),
        'documents': ((value.documents as Array<any>).map(PostPressKitBodyDocumentsInnerToJSON)),
        'profiles': ((value.profiles as Array<any>).map(PostPressKitBodyProfilesInnerToJSON)),
        'tags': ((value.tags as Array<any>).map(PostPressKitBodyTagsInnerToJSON)),
    };
}

